import Button from "components/button/Button";
import useModalScroll from "hooks/components/useModalScroll";
import React, { useEffect, useRef } from "react";
import { modal } from 'styles/commons/modal';

// 모달 컴포넌트
const BaseModal = ({
  visible,
  onClose,
  children,
  title,
  desc,
  footer,
  className,
  CommentClassName,
  icon,
  style,
  width,
}) => {
  const { preventScroll, allowScroll } = useModalScroll();
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (visible) {
      scrollYRef.current = preventScroll();
    }
    return () => {
      allowScroll(scrollYRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <modal.Overlay visible={visible.toString()} className={className}>
      <modal.Area className="modal_area">
        <modal.Frame className="modal_frame">
          <modal.Inner className="modal_inner" style={style} width={width}>
            {title && (
              <modal.Header className="modal_header">
                <h2>{title}</h2>
                {desc && <p className="header_desc">{desc}</p>}
                {icon && (
                  <Button className="close_btn" onClick={onClose}>
                    {icon}
                  </Button>
                )}
              </modal.Header>
            )}
            {children && (
              <modal.Content
                onClick={(e) => e.stopPropagation()}
                className={`modal_content ${CommentClassName || ""}`}
              >
                {children}
              </modal.Content>
            )}
            {footer && <modal.Footer>{footer}</modal.Footer>}
          </modal.Inner>
        </modal.Frame>
      </modal.Area>
    </modal.Overlay>
  );
};
export default BaseModal;
